export default "__VITE_ASSET__f9725b2b__"